import { CPBL_TEAMS } from '../enums/cpbl.enums';
import { KBO_TEAMS } from '../enums/kbo.enums';
import { MlbSportId } from '../enums/mlb-stats-api/base.enum';
import { MLB_TEAMS } from '../enums/mlb.enums';
import { NCAA_TEAMS } from '../enums/ncaa-d1.enums';
import { NPB_TEAMS } from '../enums/npm.enums';
import { Competition } from '../enums/team.enums';
import { Nullable } from '../interfaces/common/i-generics';
import { IOption } from '../interfaces/common/i-option';

type TeamOption = IOption & { sportId: Nullable<MlbSportId> };

export class TeamsHelper {
  // value is team name
  static getTeamOptions = (
    comp: Competition,
    onlyOrgs: boolean // for placeholder folders to not spawn for every affiliate
  ): IOption[] => {
    switch (comp) {
      case Competition.NPB: {
        return NPB_TEAMS.map((s) => {
          const o: IOption = {
            label: s,
            value: s,
            group: Competition.NPB,
          };
          return o;
        });
      }

      case Competition.CPBL: {
        return CPBL_TEAMS.map((s) => {
          const o: IOption = {
            label: s,
            value: s,
            group: Competition.CPBL,
          };
          return o;
        });
      }

      case Competition.MLB: {
        return MLB_TEAMS.filter((s) => !onlyOrgs || s.isOrganization).map(
          (s) => {
            const o: IOption = {
              label: s.name,
              value: s.name,
              group: Competition.MLB,
            };
            return o;
          }
        );
      }

      case Competition.KBO: {
        return KBO_TEAMS.map((s) => {
          const o: IOption = {
            label: s,
            value: s,
            group: Competition.KBO,
          };
          return o;
        });
      }

      case Competition.NCAA_D_I: {
        return NCAA_TEAMS.map((s) => {
          const o: IOption = {
            label: s.shortName,
            group: `${Competition.NCAA_D_I}: ${s.division}`,
            value: s.shortName,
          };

          return o;
        });
      }

      default: {
        return [];
      }
    }
  };

  // value is teamPk
  static getAffiliateOptions = (
    comp: Competition | undefined,
    orgPk: Nullable<number> | undefined
  ): TeamOption[] => {
    switch (comp) {
      case Competition.MLB: {
        return MLB_TEAMS.filter((s) => s.orgPk === orgPk).map((s) => {
          const o: TeamOption = {
            label: s.name,
            value: s.teamPk.toString(),
            sportId: s.sportId,
          };
          return o;
        });
      }

      default: {
        return [];
      }
    }
  };
}
